export default "__VITE_ASSET__Dvsrcfh8__"